import React from "react";
import Grid from "@material-ui/core/Grid";

import PhotosSectionCard from "./PhotosSectionCard";
import {
    PhotosPricingTableHeaderBasic,
    PhotosPricingTableHeaderLarge,
    PhotosPricingTableHeaderFullRes
} from "./photosPricingTableHeaders";

import { Table, TableHead, TableBody, TableRow } from "core/Table";
import {
    FeatureTableMobileColumnHeading,
    FeatureTableMobileBullet,
    FeatureTableMobileList
} from "core/FeatureTableMobile";
import { MaterialUIGridContainer } from "core/MaterialUI";

import {
    photosPricingBasicTable,
    photosPricingLargeTable,
    photosPricingFullResTable,
    photosPricingTableHeadingIds as headingIds
} from "./data";

const PhotosPricingTableMobile = () => (
    <MaterialUIGridContainer
        mobileMaxPadding={3}
        // passing in index 3 passes in the number "16" from the spacing array divided by 2 = 16px gutter as 8px around each item (see line 9 of core/MaterialUI/ for this spacing array)
        tabletMaxPadding={3}
        // passing in index 3 passes in the number "16" from the spacing array divided by 2 = 16px gutter as 8px around each item (see line 9 of core/MaterialUI/ for this spacing array)
    >
        <Grid item sm={12} md={6}>
            <Table>
                <TableHead>
                    <TableRow>
                        <FeatureTableMobileColumnHeading
                            id={headingIds.basic}
                            scope="col"
                        >
                            <PhotosPricingTableHeaderBasic />
                        </FeatureTableMobileColumnHeading>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <FeatureTableMobileList height="15.125rem">
                        {photosPricingBasicTable.map(bullet => (
                            <FeatureTableMobileBullet
                                key={bullet[0]}
                                isFeature={bullet[1]}
                                headers={headingIds.basic}
                            >
                                {bullet[0]}
                            </FeatureTableMobileBullet>
                        ))}
                    </FeatureTableMobileList>
                </TableBody>
            </Table>
        </Grid>
        <Grid item sm={12} md={6}>
            <Table>
                <TableHead>
                    <TableRow>
                        <FeatureTableMobileColumnHeading
                            id={headingIds.large}
                            scope="col"
                        >
                            <PhotosPricingTableHeaderLarge />
                        </FeatureTableMobileColumnHeading>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <FeatureTableMobileList height="15.125rem">
                        {photosPricingLargeTable.map(bullet => (
                            <FeatureTableMobileBullet
                                key={bullet[0]}
                                isFeature={bullet[1]}
                                headers={headingIds.large}
                            >
                                {bullet[0]}
                            </FeatureTableMobileBullet>
                        ))}
                    </FeatureTableMobileList>
                </TableBody>
            </Table>
        </Grid>
        <Grid item sm={12} md={6}>
            <Table>
                <TableHead>
                    <TableRow>
                        <FeatureTableMobileColumnHeading
                            id={headingIds.fullRes}
                            scope="col"
                        >
                            <PhotosPricingTableHeaderFullRes />
                        </FeatureTableMobileColumnHeading>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <FeatureTableMobileList height="15.125rem">
                        {photosPricingFullResTable.map(bullet => (
                            <FeatureTableMobileBullet
                                key={bullet[0]}
                                isFeature={bullet[1]}
                                headers={headingIds.fullRes}
                            >
                                {bullet[0]}
                            </FeatureTableMobileBullet>
                        ))}
                    </FeatureTableMobileList>
                </TableBody>
            </Table>
        </Grid>
        <Grid item sm={12} md={6}>
            <MaterialUIGridContainer
                mobileMaxPadding={0}
                // passing in index 0 passes in the number "0" from the spacing array divided by 2 = 0px gutter as 0px around each item (see line 9 of core/MaterialUI/ for this spacing array)
                tabletMaxPadding={0}
                // passing in index 0 passes in the number "0" from the spacing array divided by 2 = 0px gutter as 0px around each item (see line 9 of core/MaterialUI/ for this spacing array)
            >
                <Grid item sm={12} md={12} lg={6}>
                    <PhotosSectionCard />
                </Grid>
                <Grid item sm={12} md={12} lg={6}>
                    <PhotosSectionCard editorialUseOnly />
                </Grid>
            </MaterialUIGridContainer>
        </Grid>
    </MaterialUIGridContainer>
);

export default PhotosPricingTableMobile;
